export default __webpack_public_path__ + "5aaf872434228929efc86ec69afeab46.png";